import React, { ReactNode } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import ArrowLeftIcon from "@material-ui/icons/ChevronLeft";
import ArrowRightIcon from "@material-ui/icons/ChevronRight";
import { colors } from "../../theme";
import { Link } from "react-router-dom";

interface Props {
  arrowLeft: boolean;
  component?: any;
  to?: string;
  onClick?: () => void;
  children: ReactNode;
}

const useStyles = makeStyles((theme) => ({
  statementNavigationLink: {
    color: colors.STATEMENT_NAV_BUTTON_TEXT,
    textDecoration: "none",
    textTransform: "none",
    margin: 0,
    padding: 0,
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    textAlign: "center",
    cursor: "hand",
    [theme.breakpoints.down("xs")]: {
      fontSize: "14px",
      letterSpacing: "-0.03px",
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: "16px",
      letterSpacing: "-0.04px",
    },
  },
}));

export default function StatementNavigationButton({
  arrowLeft,
  to,
  onClick,
  children,
}: Props) {
  const classes = useStyles();

  return (
    <Button
      startIcon={arrowLeft ? <ArrowLeftIcon /> : false}
      endIcon={!arrowLeft ? <ArrowRightIcon /> : false}
      component={to ? Link : "button"}
      to={to || undefined}
      onClick={onClick || undefined}
      className={classes.statementNavigationLink}
    >
      {children}
    </Button>
  );
}
